import { call, put } from "redux-saga/effects";

import Api from "common/api";
import constants from "./constants";

export default {
  CreateAds: function* (data) {
    const __name = constants.CREATE_ADS;
    console.log("data", data);
    try {
      const res = yield call(Api.CreateAds, data.token, data.g_ads_id, data.fb_id);
      console.log(res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
};
